module.exports = __webpack_public_path__ + "img/banner.dc43f81a.png";